import { Route, Routes } from "react-router-dom";
import Orders from "../Orders";
import { PROFILE_ORDERS_ITEM_LINK } from "../../../../assets/utils/constants";
import OrderPage from "../OrderPage/OrderPage";

function OrdersRouter() {
    return (
        <Routes>
            <Route index element={<Orders />} />
            <Route path={`${PROFILE_ORDERS_ITEM_LINK}/:_id`} element={<OrderPage />} />
        </Routes>
    );
}

export default OrdersRouter